import React from 'react';

import { FamilyAddress } from 'common/api/crm/family/address/models/FamilyAddress';
import * as RadioGroup from '@radix-ui/react-radio-group';
import * as Label from '@radix-ui/react-label';
import { createStyles } from 'utils/createStyle';
import { PaymentOptionsContextProps } from './context';

const styles = createStyles({
    styledRadio: [
        'align-middle mr-2 cursor-pointer',
        {
            appearance: 'none',
            backgroundColor: 'transparent',
            border: 'none',
            padding: 0,
            borderRadius: '50%',
            boxShadow: 'inset 0 0 0 1px gainsboro',
            minWidth: 15,
            width: 15,
            height: 15,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',

            '& ~ &': { marginLeft: 5 },

            '&:focus': {
                outline: 'none',
                boxShadow: 'inset 0 0 0 1px dodgerblue, 0 0 0 1px dodgerblue',
            },
        },
    ],
    styledIndicator: [
        'bg-black text-brand block',
        {
            width: 7,
            height: 7,
            borderRadius: '50%',
            backgroundColor: 'dodgerblue',
        },
    ],
    address: ['', { fontSize: 17 }],
});

const getFullAddress = (address: FamilyAddress) =>
    `${address.address1} ${address.address2}, ${address.city}, ${address.state} ${address.zipCode}`;

export const AddressList = ({
    addresses,
    selectedAddress,
    setSelectedAddress,
}: PaymentOptionsContextProps) => {
    const onValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setSelectedAddress(value);
        // NOTE: we __need__ to save our selected address into local-storage in the case
        // where user enters the `oauth` flow and gets redirected away from the page
        localStorage.setItem('addr', value);
    };

    return (
        <RadioGroup.Root tabIndex={undefined} value={selectedAddress} onValueChange={onValueChange}>
            {addresses.map((address: FamilyAddress) => (
                <div key={address.id} className="flex items-center mb-2">
                    <RadioGroup.Item
                        id={address.id}
                        value={address.id}
                        className={styles.styledRadio}
                    >
                        <RadioGroup.Indicator className={styles.styledIndicator} />
                    </RadioGroup.Item>
                    <Label.Root htmlFor={address.id}>
                        <div className="flex items-center cursor-pointer">
                            <p className={styles.address}>{getFullAddress(address)}</p>
                        </div>
                    </Label.Root>
                </div>
            ))}
        </RadioGroup.Root>
    );
};
